export var Language;
(function (Language) {
    Language["DA"] = "da";
    Language["DE"] = "de";
    Language["EN"] = "en";
    Language["ES"] = "es";
    Language["FI"] = "fi";
    Language["FR"] = "fr";
    Language["IT"] = "it";
    Language["NL"] = "nl";
    Language["NB"] = "nb";
    Language["PL"] = "pl";
    Language["PT"] = "pt";
    Language["SV"] = "sv";
})(Language || (Language = {}));
export var ETranslationKey;
(function (ETranslationKey) {
    ETranslationKey["PayWith"] = "pay_with";
    ETranslationKey["ContinueWith"] = "continue_with";
    ETranslationKey["OverlayContentText"] = "overlay_content_text";
    ETranslationKey["OverlayContentButtonLabel"] = "overlay_content_button_label";
})(ETranslationKey || (ETranslationKey = {}));
